import React, {useState} from 'react';
import {useTranslation} from 'next-i18next';
import {FormControl, FormLabel, Input} from '@tempo/core';
import type {UserForm} from '@deezer/next/features/Account/type';

type UserNameProps = {
	data: string;
	isDisabled?: boolean;
	isRequired?: boolean;
	onChange?: (value: Partial<UserForm>, isValid?: boolean) => void;
};

const UserName = ({data, isDisabled, isRequired, onChange}: UserNameProps) => {
	const {t} = useTranslation('d4c');
	const [name, setName] = useState(data);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value;
		setName(value);
		if (onChange) {
			onChange({name: value});
		}
	};

	return (
		<FormControl isRequired={isRequired}>
			<FormLabel>{t('analyticsartist_text_name_d4c-web')}</FormLabel>
			<Input
				data-testid={'user-manager-form-name'}
				placeholder={t('analyticsartist_text_name_d4c-web')}
				value={name}
				onChange={handleChange}
				disabled={isDisabled}
			/>
		</FormControl>
	);
};

export default UserName;
